// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Patient } from '@medplum/fhirtypes';
import { useMedplumProfile } from '@medplum/react';
import { type UseNotificationsResult, useNotificationsForRecipient } from '@polarissleep/messaging';

/** Patient-scoped wrapper around the shared notifications hook. */
export function useNotifications(): UseNotificationsResult {
  const profile = useMedplumProfile() as Patient | undefined;
  const recipientRef = profile?.id ? `Patient/${profile.id}` : undefined;
  return useNotificationsForRecipient(recipientRef);
}
